import React from 'react';
import { createPortal } from 'react-dom';

// ----------------------------------------------------------------------

interface LoadingScreenProps {
  portal?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function LoadingScreen({ portal = false, className, style, ...other }: LoadingScreenProps) {
  const content = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backgroundColor: '#ffffff',
        ...style,
      }}
      className={className}
      {...other}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '360px',
          height: '4px',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          borderRadius: '4px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            height: '100%',
            width: '100%',
            backgroundColor: '#344733',
            borderRadius: '4px',
            animation: 'loadingProgress 1.5s ease-in-out infinite',
          }}
        />
      </div>

      <style>{`
        @keyframes loadingProgress {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );

  if (portal) {
    return createPortal(content, document.body);
  }

  return content;
}

const GlobalLoading: React.FC = () => {
  return <LoadingScreen portal={false} />;
};

export default GlobalLoading;
